import { Component, OnDestroy, OnInit } from '@angular/core'
import { NgIf } from '@angular/common'
import { StateService } from '../../services/state.service'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgIf],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {
  subscription?: Subscription
  showLoader = true

  constructor(private stateService: StateService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscription = this.stateService.isLoading$.subscribe(isLoading => {
      this.showLoader = isLoading
    })
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }
}
